._1245ro70 {
  display: inline-flex;
  align-items: baseline;
  gap: 0.4em;
  font-family: var(--xvl85n7j);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--xvl85n18);
}
._1245ro71 {
  display: inline-flex;
  align-items: baseline;
  gap: 0.15em;
  font-family: var(--xvl85n7l);
  font-variant-numeric: tabular-nums;
  color: var(--xvl85n8k);
}
._1245ro72 {
  font-family: var(--xvl85n7j);
  color: var(--xvl85n8k);
}
._1245ro73 {
  color: var(--xvl85n8m);
  margin: 0 0.2em;
}